import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '../__root';
import NewClaimPage from '@/components/new-claim/NewClaimPage';
import { useAuthTheme } from '@/contexts/AuthThemeContext';

function NewClaimPageWrapper() {
  const { authTheme, setAuthTheme } = useAuthTheme();
  return <NewClaimPage theme={authTheme} onThemeChange={setAuthTheme} />;
}

export const newClaimRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/client/new-claim',
  component: NewClaimPageWrapper,
});
